import React from "react";
import PageHero from "../components/site/PageHero";
import GalleryGrid from "../components/site/sections/GalleryGrid";
import BeforeAfterSlider from "../components/site/BeforeAfterSlider";
import FinalCTA from "../components/site/FinalCTA";
import Seo, { localBusinessSchema } from "../components/site/Seo";
import Breadcrumbs from "../components/site/Breadcrumbs";
import { IMG } from "../lib/site";

const Gallery = () => (
  <div>
    <Seo
      title="Project Gallery | Real Floor Coatings | PRYME EPOXY"
      description="Browse real garage, patio, polished concrete and commercial floor coating projects completed by PRYME EPOXY across Prescott, Flagstaff and Sedona."
      path="/gallery"
      jsonLd={localBusinessSchema()}
    />
    <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Gallery", path: "/gallery" }]} />
    <PageHero
      overline="Project Gallery"
      title="Real Floors, Real Northern Arizona Homes"
      subtitle="Every photo here is an actual PRYME EPOXY installation. This is the craftsmanship you can expect on your own project."
      image={IMG.hexLed}
    />

    <GalleryGrid showIntro={false} categorized={true} />

    <section className="pb-20 md:pb-24 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">See The Difference</span>
          <h2 className="text-3xl md:text-4xl font-light text-white mt-1">Before &amp; After</h2>
        </div>
        <div className="max-w-3xl mx-auto">
          <BeforeAfterSlider />
        </div>
      </div>
    </section>

    <FinalCTA heading="Want Your Floor In Our Gallery Next?" />
  </div>
);

export default Gallery;
